import { defineStore } from 'pinia';
import type { FeedbackPayload } from './types';
import feedbackService from './api';

interface State {
	selection: string;
}

export const useFeedbackStore = defineStore('Feedback', {
	state: (): State => ({
		selection: '',
	}),

	actions: {
		handleResetSelection() {
			this.selection = '';
		},

		async sendFeedback(payload: FeedbackPayload) {
			return await feedbackService.sendFeedback(payload);
		},
	},
});
